// Ressentis émotionnels proposés dans le formulaire Mental.
//
// `valence` ne sert plus qu'à ordonner les deux sous-listes du formulaire
// (intertitres « Ce qui pèse » / « Ce qui porte », en gris). Les agrégats de la
// page Mental ne font aucune distinction. Les libellés sont stockés tels quels
// dans `emotional_symptoms` (List[str] côté API, aucun enum backend).

export const EMOTIONAL_SYMPTOMS = [
  { id: 'anxiete',           label: 'Anxiété',              valence: 'negative', emoji: '😰' },
  { id: 'stress',            label: 'Stress',               valence: 'negative', emoji: '😰' },
  { id: 'irritabilite',      label: 'Irritabilité',         valence: 'negative', emoji: '😤' },
  { id: 'fatigue',           label: 'Fatigue',              valence: 'negative', emoji: '🥴' },
  { id: 'tristesse',         label: 'Tristesse',            valence: 'negative', emoji: '😢' },
  { id: 'manque-motivation', label: 'Manque de motivation', valence: 'negative', emoji: '😩' },
  { id: 'excitee',           label: 'Excitée',              valence: 'positive', emoji: '🤩' },
  { id: 'pleine-forme',      label: 'En pleine forme',      valence: 'positive', emoji: '💪' },
  { id: 'pleine-energie',    label: "Pleine d'énergie",     valence: 'positive', emoji: '⚡' },
  { id: 'sereine',           label: 'Sereine',              valence: 'positive', emoji: '😌' },
  { id: 'confiante',         label: 'Confiante',            valence: 'positive', emoji: '✨' },
];

export const NEGATIVE_SYMPTOMS = EMOTIONAL_SYMPTOMS.filter((s) => s.valence === 'negative');
export const POSITIVE_SYMPTOMS = EMOTIONAL_SYMPTOMS.filter((s) => s.valence === 'positive');

const BY_LABEL = Object.fromEntries(EMOTIONAL_SYMPTOMS.map((s) => [s.label, s]));

export const symptomEmoji = (label) => BY_LABEL[label]?.emoji ?? '🔸';
